var Spinner = require("components/utility/Spinner");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");

class GoogleSignin extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			dependenciesLoaded: false
		};
	}

	render() {
		if (this.state.dependenciesLoaded) {
			return (
				<div>
					<div className="g-signin2-alt" id="gSignin" ref="signinBox"
						data-onsuccess="onSignIn" data-height="30">Sign In</div>
					<button className="googleBtn buttonDefault" type="button">
						<img src={ require("misc/google-classroom.png") } />{" "}
						Log in with Google
					</button>
				</div>
			);
		} else {
			return (
				<Spinner placeholder={ true } />
			);
		}
	}

	componentDidMount() {
		$wr.loadScript("https://apis.google.com/js/client.js", "gapi", function() {
			this.setState({ dependenciesLoaded: true }, this.initGoogleSync);
		}.bind(this));
	}

	initGoogleSync() {
		var googleUser = {};
		var auth2;


		gapi.load('auth2', function() {
			auth2 = gapi.auth2.init({
				client_id: '685312089971-sq3b4ov7s8e1c8774hakb0tq5i8v9l6q.apps.googleusercontent.com',
				cookiepolicy: 'single_host_origin',
				scope: "profile"
			});

			var options = new gapi.auth2.SigninOptionsBuilder();
			options.setPrompt('select_account');

			auth2.attachClickHandler(this.refs.signinBox, {}, function(googleUser) {
				var profile = googleUser.getBasicProfile(); 
				var id_token = googleUser.getAuthResponse().id_token;
				var ssoURL = WhooosReadingServices.SsoServer.url("/google", { id_token: id_token });
				location.href = ssoURL;
			}, function(error) {
				alert(JSON.stringify(error, undefined, 2));
			});

		}.bind(this));
	}
};

GoogleSignin.propTypes = StrictPropTypes({
});

module.exports = GoogleSignin;


// WEBPACK FOOTER //
// ./modules/components/logins/GoogleSignIn.js